import React from 'react';
import ProductCard from './ProductCard';
import ProductPicturesCard from './ProductPicturesCard';

class Product extends React.Component {


  render()  {
    const {productKey, categoryKey} = this.props.match.params;
    return (
      <div>
        <ProductCard productKey={productKey} categoryKey={categoryKey}/>
        <ProductPicturesCard productKey={productKey} categoryKey={categoryKey}/>
      </div>
    );
  }

}

export default Product;



// WEBPACK FOOTER //
// ./src/Admin/Product.js